import { ArrowRight } from "lucide-react";
import { FadeIn } from "@/components/site/FadeIn";
import { NewsletterSignup } from "@/components/site/NewsletterSignup";
import { AMAZON_URL, AMAZON_EDITIONS, BOOK } from "@/data/book";

export const ClosingCta = () => (
  <section
    data-testid="closing-cta-section"
    className="relative py-28 sm:py-36 bg-[#f5f2ea] border-t border-stone-200/70 overflow-hidden"
  >
    <img
      src={BOOK.hummingbird}
      alt=""
      aria-hidden="true"
      className="pointer-events-none select-none absolute -left-20 -bottom-10 w-80 opacity-[0.13] blend-multiply rotate-12"
    />
    <div className="pointer-events-none absolute inset-0 -z-0">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[36rem] h-[36rem] rounded-full bg-[#c07a67]/10 blur-[130px]" />
    </div>

    <div className="relative max-w-2xl mx-auto px-6 text-center">
      <FadeIn>
        <p className="text-xs uppercase tracking-[0.28em] text-[#2a7b76] font-semibold mb-6">
          Begin the ascent
        </p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.1] text-[#201c19]">
          Carry these poems with you
        </h2>
        <p className="mt-7 text-lg text-stone-600 font-light leading-relaxed">
          Feel, soften, and reconnect with the parts of yourself you set aside.
          <span className="block mt-2">
            <span className="italic font-display text-[22px]">Ascent of the Hummingbird</span> is waiting on Amazon.
          </span>
        </p>
      </FadeIn>

      <FadeIn delay={0.15} className="mt-10 flex flex-col items-center gap-4">
        <a
          href={AMAZON_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="closing-buy-amazon-btn"
          className="group inline-flex items-center gap-2.5 rounded-full bg-[#c2751f] text-white text-lg font-semibold px-10 py-5 shadow-[0_14px_40px_rgba(194,117,31,0.3)] hover:bg-[#a9631a] transition-colors duration-300"
        >
          Buy on Amazon
          <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform duration-300" />
        </a>
        <p className="text-sm text-stone-500">
          {AMAZON_EDITIONS.map((e, i) => (
            <span key={e.label}>
              <a
                href={e.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`closing-edition-${e.label.toLowerCase()}`}
                className="text-[#2a7b76] underline underline-offset-2 decoration-stone-300 hover:decoration-[#2a7b76] transition-colors"
              >
                {e.label}
              </a>
              {i < AMAZON_EDITIONS.length - 1 ? <span className="mx-1.5 text-stone-300">·</span> : null}
            </span>
          ))}
          {" "}editions
        </p>
      </FadeIn>

      <NewsletterSignup />
    </div>
  </section>
);

export default ClosingCta;
